import { ChangeDetectionStrategy, Component, inject, signal } from '@angular/core';
import { MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { FormControl, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatButtonModule } from '@angular/material/button';
import { MatTableModule } from '@angular/material/table';
import { BankAccountFormatPipe } from '../pipes/bank-account-format.pipe';
import { ibanValidator } from '../../../../common/validators/iban.validator';

const MAX_FORMATTED_IBAN_LENGTH = 42;

@Component({
	selector: 'app-mass-bank-account-create-dialog',
	standalone: true,
	imports: [
		FormsModule,
		MatFormFieldModule,
		MatInputModule,
		ReactiveFormsModule,
		MatButtonModule,
		MatTableModule,
		MatDialogModule,
		BankAccountFormatPipe,
	],
	providers: [BankAccountFormatPipe],
	templateUrl: './mass-bank-account-create-dialog.component.html',
	styleUrl: './mass-bank-account-create-dialog.component.scss',
	changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MassBankAccountCreateDialogComponent {
	readonly MAX_FORMATTED_IBAN_LENGTH = MAX_FORMATTED_IBAN_LENGTH;

	readonly bankAccountNumberControl = new FormControl('', [Validators.required, ibanValidator]);

	readonly displayedColumns: string[] = ['bankAccountNumber', 'removeBtn'];

	readonly addedBankAccounts = signal<string[]>([]);

	private readonly dialogRef = inject(MatDialogRef<MassBankAccountCreateDialogComponent>);
	private readonly bankAccountFormatPipe = inject(BankAccountFormatPipe);

	onInput(event: Event): void {
		const input = event.target as HTMLInputElement;
		const raw = input.value.replace(/[^A-Za-z0-9]/g, '').toUpperCase();
		this.bankAccountNumberControl.setValue(this.bankAccountFormatPipe.transform(raw), { emitEvent: false });
	}

	addBankAccountNumber(): void {
		const formattedBankAccountNumber = this.removeWhiteSpaces(this.bankAccountNumberControl.value);

		this.addedBankAccounts.set([...this.addedBankAccounts(), formattedBankAccountNumber]);
		this.bankAccountNumberControl.setValue('');
		this.bankAccountNumberControl.markAsUntouched();
	}

	removeBankAccountNumber(index: number): void {
		const newArray = [...this.addedBankAccounts()].filter((_, i) => i !== index);
		this.addedBankAccounts.set(newArray);
	}

	closeDialogWithData(): void {
		this.dialogRef.close(this.addedBankAccounts());
	}

	private removeWhiteSpaces(value: string): string {
		return value.replace(/\s+/g, '').toUpperCase();
	}
}
